import { useState } from 'react';
import { HelpTip, Loading, PanelHowTo, api } from './_barrel.js';


        // Corporate events — recent Companies House filing history (director
        // changes, charges, accounts). Live lookup, lazy-loaded on click.
        function BusinessFilingHistory({ token, businessId, hasCompany }) {
            const [items, setItems] = useState(null);
            const [loading, setLoading] = useState(false);
            const [err, setErr] = useState(null);
            const load = async () => {
                setLoading(true); setErr(null);
                try { setItems(await api(`/api/v1/businesses/${businessId}/ch-filing-history`, {}, token)); }
                catch (e) { setErr(e.message); } finally { setLoading(false); }
            };
            if (!hasCompany) return null;
            return (
              <div className="panel mb-6">
                <div className="panel-header flex justify-between items-center">
                  <div>
                    <div className="font-display text-xl gold">Corporate Events<HelpTip text="Recent Companies House filing history — director appointments and resignations, charges, accounts and confirmation statements. Live lookup." /></div>
                    <div className="text-xs text-muted font-mono mt-1">Recent Companies House filings · newest first</div>
                  </div>
                  <button className="btn-ghost" onClick={load} disabled={loading}>{loading ? 'Loading…' : (items === null ? 'Load' : 'Reload')}</button>
                </div>
                <PanelHowTo id="business_filings" />
                <div className="px-6 py-5">
                  {err && <div className="text-[var(--red)] text-sm mb-3">{err}</div>}
                  {items === null ? (
                    <div className="text-sm text-muted">Click Load to pull recent Companies House filings — director changes, charges, accounts.</div>
                  ) : items.length === 0 ? (
                    <div className="text-sm text-muted">No filing history returned.</div>
                  ) : (
                    items.map((f, i) => (
                      <div key={i} className="flex gap-4 items-start py-2 border-b border-veil last:border-b-0">
                        <div className="flex-shrink-0 text-xs font-mono text-muted" style={{ width: '84px' }}>{f.date || '—'}</div>
                        <div className="flex-1 min-w-0">
                          <div className="text-sm text-paper">{f.description}</div>
                          {f.category && <div className="text-xs text-muted font-mono mt-1">{String(f.category).replace(/-/g, ' ')}{f.type ? ` · ${f.type}` : ''}</div>}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            );
        }

export { BusinessFilingHistory };
